import { DocSyncStatus } from '@/models/doc-sync-status.model';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DocStatusService {
  syncStatus = signal(new DocSyncStatus());
  syncLoading = signal(false);

  constructor() { }

  setSyncStatus(syncStatus: DocSyncStatus) {
    this.syncStatus.set(syncStatus);
    console.log('syncStatus set:', syncStatus);
  }

  setSyncLoading(syncLoading: boolean) {
    this.syncLoading.set(syncLoading);
  }

  setWrongState(wrongState: boolean) {
    this.syncStatus.set({...this.syncStatus(), wrongState});
  }
}
